var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 32,
    viewBox: "0 0 40 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 32,
    rx: 8,
    fill: "#16291E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1971 8.17544C27.0244 8.00395 26.8078 7.88339 26.571 7.82702C26.3342 7.77064 26.0865 7.78063 25.855 7.85589L12.4977 12.3114C12.25 12.3899 12.031 12.54 11.8686 12.7429C11.7062 12.9457 11.6075 13.1921 11.585 13.451C11.5625 13.7099 11.6173 13.9697 11.7424 14.1974C11.8674 14.4252 12.0572 14.6109 12.2877 14.7309L17.8297 17.4699L20.5687 23.0301C20.6788 23.2478 20.8472 23.4305 21.0552 23.5579C21.2632 23.6852 21.5026 23.7522 21.7465 23.7514H21.8378C22.099 23.7322 22.3484 23.6348 22.5535 23.472C22.7587 23.3092 22.9101 23.0884 22.9882 22.8384L27.5076 9.51757C27.5883 9.28743 27.6019 9.0391 27.547 8.80149C27.492 8.56389 27.3707 8.34678 27.1971 8.17544ZM13.0637 13.5713L24.7229 9.68191L18.2496 16.1551L13.0637 13.5713ZM21.8104 22.3088L19.2174 17.1229L25.6907 10.6497L21.8104 22.3088Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendicon);
export default __webpack_public_path__ + "static/media/sendicon.aa576fddd18aeedf607f98a60805a124.svg";
export { ForwardRef as ReactComponent };